"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ModalModule = _interopRequireDefault(require("./Modal.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Modal = function Modal(_ref) {
  var children = _ref.children,
      id = _ref.id;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal fade", _ModalModule["default"].modal),
    id: id,
    tabIndex: "-1",
    role: "dialog",
    "aria-hidden": "false"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-dialog", _ModalModule["default"].modalDialog),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-content", _ModalModule["default"].modalContent)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _ModalModule["default"].close,
    "aria-hidden": "true"
  }, "\xD7"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("modal-body", _ModalModule["default"].modalBody)
  }, children))));
};

var _default = Modal;
exports["default"] = _default;